import { render, staticRenderFns } from "./AssigneeDropdown.vue?vue&type=template&id=354c6976&scoped=true&"
import script from "./AssigneeDropdown.vue?vue&type=script&lang=js&"
export * from "./AssigneeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c6976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('354c6976')) {
      api.createRecord('354c6976', component.options)
    } else {
      api.reload('354c6976', component.options)
    }
    module.hot.accept("./AssigneeDropdown.vue?vue&type=template&id=354c6976&scoped=true&", function () {
      api.rerender('354c6976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/AssigneeDropdown.vue"
export default component.exports